module.exports = __webpack_public_path__ + "static/media/barcode.en.977aa2d3.png";